import Navbar from "../components/Navbar";
import "./RegistroEnviado.css";


const Accesibilidad = () => {
  return (
    <>
      <Navbar />

      <main className="main textos-legales">

        <h1>Accesibilidad</h1>
        
      </main>
    </>
  );
};

export default Accesibilidad;